import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './ProfileSkeleton.module.css';

/**
 * Loading state skeleton for the User Profile page.
 * Replicates the card layout, avatar, and form grid to minimize layout shift.
 */
export function ProfileSkeleton() {
  return (
    <div className={skeletonStyles.container} data-testid="profile-skeleton">
      {/* Header Skeleton */}
      <div className={skeletonStyles.header}>
        <Skeleton width={200} height={36} className={skeletonStyles.titleSpacing} />
        <Skeleton width={400} height={20} />
      </div>

      <div className={skeletonStyles.card}>
        {/* Profile Card Header Skeleton */}
        <div className={skeletonStyles.cardHeader}>
          <Skeleton variant="circular" width={80} height={80} />
          <div className={skeletonStyles.headerText}>
            <Skeleton width={200} height={28} className={skeletonStyles.titleSpacing} />
            <Skeleton width={150} height={20} />
          </div>
        </div>

        {/* Form Fields Skeleton */}
        <div className={skeletonStyles.formGrid}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className={skeletonStyles.field}>
              <Skeleton width={100} height={16} />
              <Skeleton width="100%" height={44} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
